/**
 * One landing address per language.
 *
 * All three translations used to live at "/" and were picked in the browser, so
 * a search engine could only ever index one of them. These addresses give each
 * its own page. Kept in a module of their own because App decides what to render
 * at a path and Landing decides what a language switch does with it, and a
 * mismatch between the two would show one language at another one's address.
 *
 * Must stay in step with src/i18n/seo.json, which builds the matching HTML, and
 * with the route whitelist in vercel.json.
 */

export const LANDING_PATHS = ["/", "/uk", "/ru"];

/**
 * Path -> language. "/" is listed like the rest, and must be: leaving it out
 * meant a visitor who had opened /uk once carried Ukrainian back to "/" in
 * localStorage and read Ukrainian copy under the English title and description
 * that page is built with - the exact mismatch these addresses exist to end.
 * The address decides the language, in both directions.
 */
export const PATH_LANG = { "/": "en", "/uk": "uk", "/ru": "ru" };

/** Language -> path. English lives at the root, not at /en. */
export const LANG_PATH = { en: "/", uk: "/uk", ru: "/ru" };
